import { fontiLegaliFixtures } from "./fixtures/fonti-legali";

export type FonteLegaleCategoria = "Normativa" | "Giurisprudenza" | "Prassi";
export type FonteLegale = {
  id: string;
  titolo: string;
  categoria: FonteLegaleCategoria;
  descrizione: string;
  estratto: string;
  aggiornatoIl: string;
};

const delay = (ms: number) => new Promise<void>((resolve) => window.setTimeout(resolve, ms));

export async function listFontiLegali(query = ""): Promise<FonteLegale[]> {
  await delay(260);
  const normalizedQuery = query.trim().toLocaleLowerCase("it-IT");
  return fontiLegaliFixtures.filter((source) =>
    !normalizedQuery || `${source.titolo} ${source.categoria} ${source.descrizione} ${source.estratto}`.toLocaleLowerCase("it-IT").includes(normalizedQuery),
  );
}

export async function getFonteLegale(id: string): Promise<FonteLegale | undefined> {
  await delay(160);
  return fontiLegaliFixtures.find((source) => source.id === id);
}
